import { Gem, User, Shield, TrendingUp, Heart } from "lucide-react";
import { Reveal, Eyebrow, CTAButton } from "./Shared";
import { IMAGES } from "../config";

const PILLARS = [
  [Gem, "Raise Standards", "Become who you choose to be"],
  [User, "Embody It", "Step into your next level self"],
  [Shield, "Protect Energy", "Keep your vision aligned"],
  [TrendingUp, "Build Legacy", "Turn your vision into reality"],
  [Heart, "Live in Alignment", "Create a life you love"],
];

export default function BonusOffer() {
  return (
    <section data-testid="offer-section" className="relative py-20 sm:py-32 overflow-hidden">
      <div className="max-w-6xl mx-auto px-4 sm:px-8">
        <Reveal>
          <Eyebrow>The Identity Shift offer</Eyebrow>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-5 font-display font-extrabold uppercase tracking-tight leading-[0.95] text-3xl sm:text-5xl max-w-4xl">
            Plans. Action. Results.{" "}
            <span className="font-serif italic normal-case font-medium text-lime">
              Held by who you become.
            </span>
          </h2>
        </Reveal>

        <div className="mt-12 sm:mt-16 grid lg:grid-cols-12 gap-10 items-center">
          <Reveal className="lg:col-span-7">
            <div
              data-testid="offer-photo"
              className="relative rotate-[-1deg] border border-cream/15 bg-black shadow-[0_40px_80px_-20px_rgba(0,0,0,0.9)] overflow-hidden group"
            >
              <img
                src={IMAGES.offer}
                alt="The BLUEPRINT Identity Shift offer — Dasha Love with the course, the Becoming HER Blueprint book and the work desk"
                className="w-full h-auto block transition-transform duration-700 group-hover:scale-[1.02]"
                loading="lazy"
              />
              <span className="absolute top-3 left-3 bg-ink/70 backdrop-blur px-2.5 py-1 font-mono text-[8px] tracking-[0.25em] uppercase text-cream/90 border border-cream/15">
                Blueprint™ — Identity Shift
              </span>
              <span className="absolute bottom-3 right-3 bg-lime text-ink font-mono text-[9px] font-semibold tracking-[0.12em] uppercase px-3 py-1.5 -rotate-2">
                The $111 offer
              </span>
            </div>
          </Reveal>

          <div className="lg:col-span-5">
            <ul className="border-t border-cream/10">
              {PILLARS.map(([Icon, title, desc], i) => (
                <Reveal key={title} delay={i * 0.05} y={14}>
                  <li
                    data-testid={`pillar-item-${i + 1}`}
                    className="flex items-center gap-4 py-4 border-b border-cream/10"
                  >
                    <span className="w-9 h-9 shrink-0 rounded-full border border-gold/50 text-gold flex items-center justify-center">
                      <Icon size={15} />
                    </span>
                    <div>
                      <p className="font-display font-bold uppercase tracking-tight text-base sm:text-lg">
                        {title}
                      </p>
                      <p className="text-xs sm:text-sm text-fog">{desc}</p>
                    </div>
                  </li>
                </Reveal>
              ))}
            </ul>
            <Reveal delay={0.3}>
              <p className="mt-5 font-mono text-[10px] tracking-[0.3em] uppercase text-gold">
                Plans · Action · Results
              </p>
            </Reveal>
          </div>
        </div>

        <Reveal delay={0.1}>
          <div
            data-testid="bonus-book-card"
            className="mt-14 sm:mt-20 relative overflow-hidden border border-gold/40 bg-gradient-to-br from-[#171410] to-coal p-6 sm:p-10 grid sm:grid-cols-12 gap-8 items-center"
          >
            <span className="absolute top-0 right-0 bg-gold text-ink font-mono text-[9px] font-semibold tracking-[0.18em] uppercase px-4 py-1.5">
              Bonus — included
            </span>
            <div className="sm:col-span-4 w-full max-w-[220px] mx-auto">
              <img
                data-testid="bonus-book-image"
                src={IMAGES.book}
                alt="BECOMING HER Blueprint™ — the bonus book by Dasha Love"
                className="w-full h-auto rotate-2 border border-cream/10 shadow-[0_30px_60px_-15px_rgba(0,0,0,0.9)]"
                loading="lazy"
              />
            </div>
            <div className="sm:col-span-8">
              <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-gold">
                Bonus with every order
              </p>
              <h3 className="mt-3 font-display font-extrabold uppercase tracking-tight leading-[0.95] text-2xl sm:text-4xl">
                Becoming{" "}
                <span className="font-serif italic normal-case font-medium text-lime">HER</span>{" "}
                Blueprint™
              </h3>
              <p className="mt-4 max-w-lg text-sm sm:text-base leading-relaxed text-fog">
                Dasha Love&rsquo;s unfiltered companion read —{" "}
                <span className="text-cream">
                  &ldquo;Become a badass who goes all in… or the Man she chooses.&rdquo;
                </span>{" "}
                Raise standards. Embody it. Protect energy. Build legacy. Live in alignment.
                Included with your $111 order — details land in your confirmation email.
              </p>
              <div className="mt-6">
                <CTAButton testId="offer-cta-button">Claim the offer — $111</CTAButton>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
